import { render, staticRenderFns } from "./SummaryArtist.vue?vue&type=template&id=7103d40e"
import script from "./SummaryArtist.vue?vue&type=script&lang=js"
export * from "./SummaryArtist.vue?vue&type=script&lang=js"
import style0 from "./SummaryArtist.vue?vue&type=style&index=0&id=7103d40e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports